import React from 'react';

const Home = () => {
  return (
    <div>
      <h1>Welcome to Williams Website</h1>
      <p>Professional bookkeeping services to help you manage your finances efficiently.</p>
      <p>Qualifications.</p>
    </div>
  );
};

export default Home;
